import {
  Color, PaintStyle, TextureKinds, BorderStyle,
} from "../../../../domain/drawing";

export class HtmlColorCodeTranslator {
  static toColor(code: string): Color {
    return this.isCodeValid(code)
      ? new Color(code)
      : new Color("transparent");
  }

  static toPaintStyle(code: string): PaintStyle {
    return new PaintStyle(
      this.toColor(code),
      this.isCodeValid(code) ? TextureKinds.Fill : TextureKinds.None
    );
  }

  /**
   * 図形項目以外（テキストボックスなど）のためのTextureKinds.Fill固定の変換
   * TextureKinds.Fillにしておかないとコンボボックスなどで項目を切り替えたときに色が反映されない
   */
  static toPaintStyleFill(code: string): PaintStyle {
    return new PaintStyle(
      this.toColor(code),
      TextureKinds.Fill
    );
  }

  static toBorderStyle(code: string, width: number = 1): BorderStyle {
    return new BorderStyle(
      this.toColor(code),
      width,
    );
  }

  static fromColor(color: Color): string {
    return this.isCodeValid(color.value)
      ? color.value
      : null;
  }

  static fromPaintStyle(style: PaintStyle): string {
    return (!style || (style.kind === TextureKinds.None))
      ? null
      : this.fromColor(style.color);
  }

  static isCodeValid(code: string): boolean {
    return code
      && !!code.match(/^#[0-9a-fA-F]{6}$/);
  }
}
